// ------------------------------------
// Constants
// ------------------------------------
import axios from 'axios'
import { protocol, origin, getHeaders } from './addons'
import Notifications from 'react-notification-system-redux'
import {
  addEmailSuccess,
  delEmailSuccess,
  addEmailError,
  delEmailError,
  emailExistError
} from './toasts'
export const GET_EMAILS = 'GET_EMAILS'
export const ADD_EMAIL = 'ADD_EMAIL'

// ------------------------------------
// Actions
// ------------------------------------
const getEmailsAction = (data = undefined) => {
  return {
    type: GET_EMAILS,
    data: data
  }
}

const addEmailAction = (data = false) => {
  return {
    type: ADD_EMAIL,
    data: data
  }
}

export const getEmails = () => {
    return (dispatch) => {
        return new Promise((resolve) => {
          axios.get(`${protocol}//${origin}/api/newsletters`)
            .then((json) => {
              dispatch(getEmailsAction(json.data))
              resolve()
            })
            .catch((error) => {
              console.log(error)
              resolve()
            })
        })
    }
  }

  export const addEmail = (data) => {
    return (dispatch) => {
      return new Promise((resolve) => {
        axios.post(`${protocol}//${origin}/api/newsletters`, data, getHeaders())
          .then((json) => {
            if (('code' in json.data) && json.data.code === 11000) {
              dispatch(addEmailAction(json.data.code === 11000))
              dispatch(Notifications.error(emailExistError))
            } else {
              dispatch(Notifications.success(addEmailSuccess))
            }
            resolve()
          })
          .catch((error) => {
            console.log(error)
            dispatch(Notifications.error(addEmailError))
            resolve()
          })
      })
    }
  }

  export const deleteEmail = (id) => {
    return (dispatch) => {
      return new Promise((resolve) => {
        axios.delete(`${protocol}//${origin}/api/newsletters/${id}`, getHeaders())
          .then((response) => {
            dispatch(Notifications.success(delEmailSuccess))
            resolve()
          })
          .catch((error) => {
            console.log(error + 'r')
            dispatch(Notifications.error(delEmailError))
            resolve()
          })
      })
    }
  }

export const actions = { getEmails, addEmail, deleteEmail }

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [GET_EMAILS]: (state, action) => {
    return {
      ...state,
      emails: action.data
    }
  },
  [ADD_EMAIL]: (state, action) => {
    return {
      ...state,
      existError: action.data
    }
  }
}

const initialState = {
  emails: [],
  existError: false
}

export default function newsletterReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/newsletter.js